// 임플란트 갯수 4개
// 랜딩 16번
// 데이터 들어가는지 잘 확인해야하는 랜딩

// formFieldColor="white" (이름&번호 input 배경 흰색)

import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";

import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import PrivacyContent from "./PrivacyContent";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";

function RandingStyle9({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  formFieldColor,
  postBTN,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img7Path,
  img8Path,
  img9Path,
  periodType,
  numberColor,
  keepBTN,
  companyName,
  footerPath,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  eventDates,
  callNumber,
  adTarget,
  privacyMessage,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className="form-container">
      <div className="step1">
        {img1Path && (
          <a href={callNumber} style={{ display: "contents" }}>
            <img src={img1Path} alt="임플란트 고민중이세요?" />
          </a>
        )}
        {img2Path && <img src={img2Path} />}
        <p class="safe-notice">
          안심하세요! <span>{companyName}</span>에서는 고객님의 소중한
          개인정보를
          <br /> 상담 외 어떠한 목적으로도 사용하지 않습니다.
        </p>

        {/* 연락처 입력란 */}
        <div className="qBox">
          <p className="benefitInfo">
            {eventDates && <BenefitPeriod periodType={periodType} />}
            <br />
            이벤트 대상자 : {adTarget ? adTarget : "해당 매체 이용자"}
          </p>
          <form
            // className="formBoxStyle9"
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div
              className={`formField ${
                formFieldColor === "white" ? "white" : ""
              }`}
            >
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
              formFieldColor={formFieldColor}
            />

            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />

            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={companyName} />
                </div>
              </div>
            )}
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>
        {img3Path && <img src={img3Path} />}
        {img4Path && <img src={img4Path} />}
        {img5Path && <img src={img5Path} />}
        {img6Path && <img src={img6Path} />}
        {img7Path && <img src={img7Path} />}
        {img8Path && <img src={img8Path} />}
        {img9Path && <img src={img9Path} />}
      </div>
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle9;
